// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"e985dd86","154":"85a928f8"}[chunkId] + ".chunk.css";
};